import * as types from './mutation-types'
import axios from 'axios'
import cmnConst from '@/assets/js/constant.js'

const uri = `${cmnConst.API_URL}/api/v3/`

export default {
	namespaced: true,

	state: {
		sleepData: null,
		heartbeatData: null,
		summaryData: null,
		userInfo: null
	},

	mutations: {
		[types.SET_SLEEP_DATA] (state, sleepData) {
			state.sleepData = sleepData
		},
		[types.SET_HEARTBEAT_DATA] (state, heartbeatData) {
			state.heartbeatData = heartbeatData
		},
		[types.SET_SUMMARY_DATA] (state, summaryData) {
			state.summaryData = summaryData
		},
		[types.SET_USER_INFO] (state, userInfo) {
			state.userInfo = userInfo
		}
	},

	actions: {
		// Fitbit睡眠データを取得するAPI
		[types.SET_SLEEP_DATA] ({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios.request({
					method: 'post',
					url: `${uri}fitbit/getsleep.json`,
					params: {
						user_id: payload.user_id,
						user_token: payload.user_token,
						date: payload.date
					}
				}).then(res => {
					// NOTE: result_codeが1001以外はエラー
					if (res.data.result_code !== 1001) {
						commit(types.SET_SLEEP_DATA, null)
						reject(res)
					} else {
						const data = res.data
						commit(types.SET_SLEEP_DATA, data)
						resolve(data)
					}
				}).catch(error => {
					commit(types.SET_SLEEP_DATA, null)
					reject(error)
				})
			})
		},

		// Fitbit心拍データを取得するAPI
		[types.SET_HEARTBEAT_DATA] ({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios.request({
					method: 'post',
					url: `${uri}fitbit/getheartrate.json`,
					params: {
						user_id: payload.user_id,
						user_token: payload.user_token,
						date: payload.date
					}
				}).then(res => {
					// NOTE: result_codeが1001以外はエラー
					if (res.data.result_code !== 1001) {
						commit(types.SET_HEARTBEAT_DATA, null)
						reject(res)
					} else {
						const data = res.data
						commit(types.SET_HEARTBEAT_DATA, data)
						resolve(data)
					}
				}).catch(error => {
					commit(types.SET_HEARTBEAT_DATA, null)
					reject(error)
				})
			})
		},

		// Fitbitサマリーデータを取得するAPI
		[types.SET_SUMMARY_DATA] ({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios.request({
					method: 'post',
					url: `${uri}fitbit/summary.json`,
					params: {
						user_id: payload.user_id,
						user_token: payload.user_token
					}
				}).then(res => {
					// NOTE: result_codeが1001以外はエラー
					if (res.data.result_code !== 1001) {
						commit(types.SET_SUMMARY_DATA, null)
						reject(res)
					} else {
						const data = res.data
						commit(types.SET_SUMMARY_DATA, data)
						resolve(data)
					}
				}).catch(error => {
					commit(types.SET_SUMMARY_DATA, null)
					reject(error)
				})
			})
		},

		// Fitbit連携情報を取得するAPI
		[types.SET_USER_INFO] ({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios.request({
					method: 'get',
					url: `${uri}fitbit/userinfo.json`,
					params: {
						user_id: payload.user_id,
						user_token: payload.user_token
					}
				}).then(res => {
					// NOTE: result_codeが1001以外はエラー
					if (res.data.result_code !== 1001) {
						commit(types.SET_USER_INFO, null)
						reject(res)
					} else {
						const data = res.data
						commit(types.SET_USER_INFO, data)
						resolve(data)
					}
				}).catch(error => {
					commit(types.SET_USER_INFO, null)
					reject(error)
				})
			})
		}
	},

	getters: {
		sleepData (state) {
			return state.sleepData
		},
		heartbeatData (state) {
			return state.heartbeatData
		},
		summaryData (state) {
			return state.summaryData
		},
		userInfo (state) {
			return state.userInfo
		}
	}
}
